/* eslint-disable */
import { getUploadLivraisonErrorMessage } from "../../utils/uploadLivraisonError";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Orders.css";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { Dropdown, Menu } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { datat } from "../../components/orders/DataTableTemplatingDemo/data";
import { CommuneZimou } from "../../components/orders/DataTableTemplatingDemo/communeZimou";
import {
  setDoc,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  writeBatch,
  getDoc,
  Timestamp,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase";
import { format } from "date-fns";
import Swal from "sweetalert2";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  PencilIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import ModalAdd from "../../components/orders/model/ModelAdd";
import { MessageCircleIcon } from "lucide-react";
import axios from "axios";
import apicache from "../../components/clearCach/clear";
import freeCountries from "../../utils/freeCountries.json";
import { useTranslation } from "react-i18next";
import { consumeSubscriptionToken } from "../../utils/subscriptionPayment";
import { fetchAccount } from "../../redux/account/account";
import { getMerchantOrder } from "../../api/foorwebOrders";

export default function OrderProfile() {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const location = useLocation();
  const dispatch = useDispatch();
  const [showSideBar, setShowSideBar] = useState(true);
  const [showSubmenus, setShowSubmenus] = useState({});
  const account = useSelector((state) => state.AccountReducer);
  const isFreeCountry = freeCountries.includes(account?.country);
  const orders = useSelector((state) => state.OrdersReducer);
  const store = useSelector((state) => state.StoreReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const currencyMap = {
    دج: {
      ar: "دج",
      fr: "DA",
      en: "DZD",
    },
  };
  const localizedCurrency =
    currencyMap[store.currencySymbol]?.[i18n.language] || store.currencySymbol;
  const { t } = useTranslation();
  useEffect(() => {
    // تحديث حالة الـ sidebar استنادًا إلى عرض الشاشة
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    // استدعاء الوظيفة عند تحديث حجم الشاشة
    window.addEventListener("resize", handleResize);

    // قم بتشغيل الوظيفة مرة عند تحميل الصفحة لتحديد الحالة الابتدائية
    handleResize();

    // إلغاء تسجيل الاستماع عندما يتم تفريغ المكون
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { id } = useParams();
  const navigate = useNavigate();
  const [orderIds, setOrderIds] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const url =
    "https://orders-management-dev.maystro-delivery.com/api/stores/orders/";
  const url1 = "https://backend.foorweb.store/api/UploadLivraison";
  const url4 = "https://app.noest-dz.com/api/public/create/order";
  const url5 = "https://backend.foorweb.store/api/UploadLivraison";
  const url6 = "https://backend.foorweb.store/api/UploadLivraison";

  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleDropdownClick = (e) => {
    if (order?.isValid) {
      Swal.fire({
        title: t("ui.orderInactive"),
        text: t("orderDetails.alerts.call.text"),
        icon: "info",
        confirmButtonText: t("orderDetails.alerts.ok"),
      });
      e.stopPropagation(); // Prevent dropdown from opening
      return;
    }

    // If order is valid, toggle dropdown visibility
    setDropdownVisible((prevState) => !prevState);
  };

  useEffect(() => {
    // prefer the filtered list that was passed from the table
    if (location.state?.filteredOrderIds?.length > 0) {
      setOrderIds(location.state.filteredOrderIds);
      const idx = location.state.filteredOrderIds.indexOf(id);
      setCurrentIndex(idx !== -1 ? idx : 0);
      return;
    }

    // fallback: full list from redux
    if (orders.length > 0) {
      const ids = orders.map((order) => order.id);
      setOrderIds(ids);
      const idx = ids.indexOf(id);
      setCurrentIndex(idx !== -1 ? idx : 0);
    }
  }, [orders, id, location.state]);

  const goToPrevious = () => {
    if (currentIndex <= 0) return;

    const newIndex = currentIndex - 1;
    const nextId = orderIds[newIndex];

    setCurrentIndex(newIndex);
    navigate(`/orderProfile/${nextId}`, {
      replace: true,
      state: {
        filteredOrderIds: orderIds,
      },
    });
  };

  const goToNext = () => {
    if (currentIndex >= orderIds.length - 1) return;

    const newIndex = currentIndex + 1;
    const nextId = orderIds[newIndex];

    setCurrentIndex(newIndex);
    navigate(`/orderProfile/${nextId}`, {
      replace: true,
      state: {
        filteredOrderIds: orderIds,
      },
    });
  };

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [dataForm, setDataForm] = useState({
    user: account.uer,
    productId: "",
    name: "",
    phone: "",
    state: "",
    paid: "0",
    address: "",
    commune: "",
    deleveryStatus: "1",
    stopdeskDelivery: false,
    deleveryPrice: 0,
    products: [],
    deliveryPrice: 0,
    qty: "",
    total: 0,
    options: "",
    paymentType: "دفع عند الاستلام",
    timeStamp: serverTimestamp(),
  });

  useEffect(() => {
    const fetchOrderDetails = async () => {
      setLoading(true);

      try {
        // 1- data passed via navigation state
        if (location.state?.orderData) {
          setOrder(location.state.orderData);
          return;
        }

        // 2- order already exists in redux
        const orderFromRedux = orders.find((o) => o.id === id);
        if (orderFromRedux) {
          setOrder(orderFromRedux);
          return;
        }

        // 3- fallback: fetch from backend (needed for locked or billing protected orders)
        if (!account?.user) {
          console.warn("Account not ready yet");
          return;
        }

        const fetched = await getMerchantOrder({
          storeId: account.user,
          orderId: id,
        });

        if (fetched) {
          setOrder(fetched);
        } else {
          Swal.fire({
            title: t("ship.error"),
            text: t("orderDetails.alerts.notFoundText"),
            icon: "error",
            confirmButtonText: t("orderDetails.alerts.ok"),
          });
          setOrder(null);
        }
      } catch (error) {
        console.error("Error fetching order details:", error);

        // try redux one more time in case of network issues
        const orderFromRedux = orders.find((o) => o.id === id);
        if (orderFromRedux) {
          setOrder(orderFromRedux);
          return;
        }

        Swal.fire({
          title: t("ship.error"),
          text: t("orderDetails.alerts.fetchErrorText"),
          icon: "error",
          confirmButtonText: t("orderDetails.alerts.ok"),
        });
        setOrder(null);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchOrderDetails();
    }
  }, [id, location.state, account?.user, orders]);

  const toggleSubmenu = (products) => {
    setShowSubmenus((prevShowSubmenus) => ({
      ...prevShowSubmenus,
      [products]: !prevShowSubmenus[products],
    }));
  };

  const handleUpdate = async (order) => {
    console.log("Order ID:", order);

    setDataForm(order);
    setShowModal(true);
  };

  const handleModalSave = (updatedOrderData) => {
    setOrder(updatedOrderData); // Update local state
  };

  const onDeleteProduct = async (productToDelete) => {
    try {
      // Log the clicked product name and order ID
      console.log("Product to delete:", productToDelete.name);
      console.log("Order ID:", id);

      // Check if the order ID is properly set
      if (!id) {
        console.error("Order ID is missing or undefined.");
        Swal.fire(t("ship.error"), "رقم الطلب غير متوفر.", "error");
        return;
      }

      // Check if this is the last product in the order
      if (data && data.products && data.products.length === 1) {
        Swal.fire({
          title: t("orderDetails.alerts.lastProductDeletionTitle"),
          text: t("orderDetails.alerts.lastProductDeletionText"),
          icon: "warning",
          confirmButtonText: t("orderDetails.alerts.ok"),
          confirmButtonColor: "#6c757d",
        });
        return;
      }

      // Confirm deletion with the user
      const result = await Swal.fire({
        title: t("cashBack.swal.deleteConfirm.title"),
        text: t("orderDetails.alerts.confirmDeleteText"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: t("ship.delete"),
        cancelButtonText: t("annule"),
      });

      if (result.isConfirmed) {
        // Check if we're online
        if (!navigator.onLine) {
          Swal.fire({
            title: t("orderDetails.alerts.offlineTitle"),
            text: t("orderDetails.alerts.offlineText"),
            icon: "error",
            confirmButtonText: t("orderDetails.alerts.ok"),
          });
          return;
        }

        // Use data from Redux instead of fetching from Firebase
        if (data) {
          const currentProducts = data.products || [];

          console.log("Current products:", currentProducts); // Log existing products

          // Remove the product by name
          const updatedProducts = currentProducts.filter(
            (product) => product.name !== productToDelete.name,
          );

          console.log("Updated products after deletion:", updatedProducts); // Log updated products

          // Recalculate the total price
          const updatedTotal = updatedProducts.reduce((acc, product) => {
            return acc + product.price * product.quantity;
          }, 0);

          // Update the document in Firebase
          await updateDoc(doc(db, "orders", id), {
            products: updatedProducts,
            total: updatedTotal,
          });

          // Update the state locally
          setOrder((prevOrder) => ({
            ...prevOrder,
            products: updatedProducts,
            total: updatedTotal,
          }));

          console.log("Successfully deleted from Firestore");

          // Show success message
          Swal.fire(t("ship.delete_success"), "تم حذف المنتج بنجاح.", "success");
        } else {
          console.error("Order not found in Redux!");
          Swal.fire(t("ship.error"), "لم يتم العثور على الطلب.", "error");
        }
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      Swal.fire(t("ship.error"), "فشل في حذف المنتج.", "error");
    }
  };

  const statusOptions = {
    1: t("orderDetails.statusOptions.1"),
    3: t("orderDetails.statusOptions.3"),
    "11-2": t("orderDetails.statusOptions.11-2"),
    "11-3": t("orderDetails.statusOptions.11-3"),
    6: t("orderDetails.statusOptions.6"),
    "11-5": t("orderDetails.statusOptions.11-5"),
    "11-1": t("orderDetails.statusOptions.11-1"),
    "11-4": t("orderDetails.statusOptions.11-4"),
    4: t("orderDetails.statusOptions.4"),
    5: t("orderDetails.statusOptions.5"),
  };

  const statusOptions2 = [
    {
      value: "3",
      label: t("orderDetails.orderStatus.confirmed"),
      color: "#25c7bf",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/8888/8888205.png",
    },
    {
      value: "4",
      label: t("orderDetails.orderStatus.withDeliveryCompany"),
      color: "#8c5fa5",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/1559/1559859.png",
    },
    {
      value: "5",
      label: t("orderDetails.orderStatus.completed"),
      color: "#49a688",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/6815/6815043.png",
    },
    {
      value: "6",
      label: t("orderDetails.orderStatus.cancelled"),
      color: "#e87778",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/391/391247.png",
    },
    {
      value: "11-1",
      label: t("orderDetails.orderStatus.waitingClientCall"),
      color: "#0074D9",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/2593/2593514.png",
    },
    {
      value: "11-2",
      label: t("orderDetails.orderStatus.noAnswer"),
      color: "#D3D3D9",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/9946/9946401.png",
    },
    {
      value: "11-3",
      label: t("orderDetails.orderStatus.postponed"),
      color: "#e1a626",
      buttonImage: "../agenda.png",
    },
    {
      value: "11-4",
      label: t("orderDetails.orderStatus.lineClosed"),
      color: "#000000",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/8402/8402548.png",
    },
    {
      value: "11-5",
      label: t("orderDetails.orderStatus.cancelledByClient"),
      color: "#800080",
      buttonImage: "https://cdn-icons-png.flaticon.com/128/7787/7787073.png",
    },
  ];

  const orderCurrent = orders.find((order) => order.id === id);

  const deleveryStatus = orderCurrent?.deleveryStatus || "";

  const changeStatus = async (newStatus) => {
    try {
      if (!navigator.onLine) {
        Swal.fire({
          title: t("orderDetails.alerts.offlineTitle"),
          text: t("ui.offlineStatusError"),
          icon: "error",
          confirmButtonText: t("orderDetails.alerts.ok"),
        });
        return;
      }

      const currentTime = new Date();

      // Update in Firebase
      await updateDoc(doc(db, "orders", id), {
        deleveryStatus: newStatus,
        statusTimeline: arrayUnion({
          status: newStatus,
          timestamp: currentTime,
        }),
      });

      // Show success message
      Swal.fire(t("ui.updated"), "تم تحديث حالة الطلب بنجاح.", "success");

      // Update the local state
      setOrder((prevOrder) => ({
        ...prevOrder,
        deleveryStatus: newStatus,
        statusTimeline: [
          ...(prevOrder.statusTimeline || []),
          { status: newStatus, timestamp: currentTime },
        ],
      }));
    } catch (error) {
      console.error("Error updating order status:", error);
      Swal.fire(t("ship.error"), "فشل في تحديث حالة الطلب.", "error");
    }
  };

  const getButtonImage = (status) => {
    if (!order) {
      return "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"; // Default image
    }
    const statusOption = statusOptions2.find(
      (option) => option.value === status,
    );
    return statusOption
      ? statusOption.buttonImage
      : "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
  };

  const shippingOptions = [];
  if (!!store.Maystro) shippingOptions.push({ value: "1", label: "Maystro" });
  if (!!store.Zrexpress)
    shippingOptions.push({ value: "2", label: "Zr express" });
  if (!!store.Ecotrack && !!store.Uecotrack)
    shippingOptions.push({ value: "3", label: "Ecotrack" });
  if (!!store.Userguid && !!store.ApitokenNord)
    shippingOptions.push({ value: "4", label: "Nord Et Ouest" });

  const data = useSelector((state) =>
    state.OrdersReducer.find((order) => order.id === id),
  );

  const changeShip = async (data, status) => {
    const adresse = data.address ? data.address : ".";
    let productDetails = "";

    if (Array.isArray(data.products) && data.products.length > 0) {
      data.products.forEach((product, index) => {
        let productName = product.name;
        const quantity = product.quantity;

        if (data.stockDelivery === true) {
          productDetails = product.sku;
          return;
        }

        // ! إذا كان هناك منتج واحد، استخدم الاسم بالكامل بدون تقصير
        if (data.products.length === 1) {
          productName = product.name;
        } else if (productName.length > 10) {
          // ! تقصير اسم المنتج إلى 10 أحرف وإضافة ثلاث نقاط إذا كان أطول من ذلك
          productName = productName.substring(0, 15) + "...";
        }

        // ! الحصول على اللون مباشرةً كسلسلة
        const color = product.options?.color || "";

        // ! الحصول على الحجم مباشرةً كسلسلة
        const size = product.options?.size || "";

        const offer = product.options?.offer
          ? `العرض: ${product?.options?.offer}`
          : "";

        // ! تجميع التفاصيل ووضعها بين قوسين
        const details = `(${productName} × ${quantity} ${
          color && `+ ${color}`
        } ${size && `+ ${size}`} ${offer && `+ ${offer}`})`;

        // ! إضافة المنتج إلى السلسلة النهائية مع "+" بين المنتجات
        productDetails += details;

        // ! إضافة "+" إذا لم يكن هذا هو المنتج الأخير
        if (index < data.products.length - 1) {
          productDetails += " + ";
        }
      });
    }

    var totalNumber = Number(data.total);
    if (status === "1") {
      // Maystro company
      const stopdesk =
        data.stopdeskDelivery != null && data.stopdeskDelivery ? 2 : 1;

      let total = data.total;
      if (data.deleveryPrice) {
        total += data.deleveryPrice;
      }

      const products = [];
      if (data.products) {
        for (const key in data.products) {
          const product = data.products[key];
          const sku = productss.find((p) => p.name === product.name)?.sku;
          products.push({
            product: sku,
            quantity: product.quantity,
          });
        }
      }
      const WilayaMay = wilayaMaystro.find((d) => d[1] === data.state)?.[0];
      const communeMay = await convertirCommuneArabeVersFrancais(
        data.commune,
        WilayaMay,
        datat,
      );
      console.log(communeMay);
      const communeMaystro = communesMaystro.filter(
        (d) => d.fields.name === communeMay,
      )[0]?.pk;

      const postData = {
        external_order_id: "REFERENCE-ID",
        destination_text: adresse,
        product_price: total,
        customer_name: data.name,
        customer_phone: data.phone,
        express: false,
        commune: communeMaystro,
        delivery_type: stopdesk,
        note_to_driver: data.note,
        details: products,
      };
      console.log(postData);
      axios
        .post(url, [postData], {
          headers: {
            Authorization: `Token ${store.Maystro}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          const tracking = response.data[0]?.tracking;
          if (tracking) {
            setDoc(doc(db, "orders", data.id), {
              ...data,
              deleveryStatus: "4",
              tracking: tracking,
              DC: status,
              MaystroId: response.data[0]?.id,
            });
          } else {
            const message = response.data[0]?.errors[0]?.detail || "erreur !";
            setErrorMessage(message);
          }
        })
        .catch((error) => {
          setErrorMessage(
            getUploadLivraisonErrorMessage(error) || (error.response?.data?.detail || "Une erreur est survenue"),
          );
        });
    } else if (status === "2") {
      //Zr Express
      const headers = {
        "zr-express-token": `${store.Zrexpress}`,
        "zr-express-cle": `${store.ZrexpressC}`,
        "Content-Type": "application/json",
      };
      let wilaya = datat.filter((d) => d.wilaya_name === data.state)[0]
        .wilaya_code;

      if (wilaya.length == 1) {
        wilaya = "0" + wilaya;
      }
      const postData = {
        keyword: "zrexpress",
        data: {
          Colis: [
            {
              // Premier Colis
              TypeLivraison: data.stopdeskDelivery ? "1" : "0", // Domicile : 0 & Stopdesk : 1
              TypeColis: "0", // Echange : 1
              Confrimee: "", // 1 pour les colis Confirmer directement en pret a expedier
              Client: data.name,
              MobileA: data.phone,
              MobileB: data.phone,
              Adresse: adresse,
              IDWilaya: wilaya,
              Commune: datat.filter((d) => d.commune_name === data.commune)[0]
                .commune_name_ascii,
              Total: data.total,
              Note: data.note,
              TProduit: `${productDetails}`,
              id_Externe: "01", // Votre ID ou Tracking
              Source: "",
            },
          ],
        },
      };

      axios
        .post(url1, postData, { headers })
        .then((response) => {
          const tracking = response.data?.data?.Colis?.[0]?.Tracking;
          // alert(tracking);
          if (tracking != null) {
            setDoc(doc(db, "orders", data.id), {
              ...data,
              deleveryStatus: "4",
              tracking: tracking,
              DC: status,
            });
          }
          //here fix with toast
        })
        .catch((error) => {
          setErrorMessage(getUploadLivraisonErrorMessage(error) || (error.data.data));
        });
    } else if (status === "4") {
      axios
        .post(url4, {
          user_guid: `${store.Userguid}`,
          api_token: `${store.ApitokenNord}`,
          type_id: 1,
          stop_desk: data.stopdeskDelivery ? 1 : 0,
          produit: `${productDetails}`,
          client: data.name,
          phone: data.phone,
          quantite: data.qty,
          adresse: adresse,
          wilaya_id: datat.filter((d) => d.wilaya_name === data.state)[0]
            .wilaya_code,
          commune: datat.filter((d) => d.commune_name === data.commune)[0]
            .commune_name_ascii,
          montant: data.total,
          NoteClient: data.note,
          Remboursement: 0,
          poids: `0`,
        })
        .then((response) => {
          setDoc(doc(db, "orders", data.id), {
            ...data,
            deleveryStatus: "4",
            DC: status,
          });
        })
        .catch((error) => {
          setErrorMessage(getUploadLivraisonErrorMessage(error) || (error.response.data.error));
        });
    } else if (status === "3") {
      //ecotrack
      console.log(
        datat.filter((d) => d.commune_name === data.commune)[0]
          .commune_name_ascii,
      );
      axios
        .post(
          `${store.Uecotrack}/api/v1/create/order?api_token=${
            store.Ecotrack
          }&reference&nom_client=${data.name}&telephone=${
            data.phone
          }&telephone_2=${data.phone}&adresse=${adresse}&code_postal&commune=${
            datat.filter((d) => d.commune_name === data.commune)[0]
              .commune_name_ascii
          }&code_wilaya=${
            datat.filter((d) => d.wilaya_name === data.state)[0].wilaya_code
          }&montant=${data.total}&remarque=${
            data.note
          }&produit=${productDetails}&stock=${
            data.stockDelivery ? 1 : 0
          }&quantite=${data.qty}&produit_a_recupere&boutique&type=1&stop_desk=${
            data.stopdeskDelivery ? 1 : 0
          }`,
        )
        .then((response) => {
          if (response.status === 200) {
            const formattedResponse = JSON.stringify(response, null, 2);
            setDoc(doc(db, "orders", data.id), {
              ...data,
              DC: status,
              deleveryStatus: "4",
              tracking: response.data.tracking,
            });
          }
        })
        .catch((error) => {
          setErrorMessage(getUploadLivraisonErrorMessage(error) || (error.response.data.message));
        });
    } else if (status === "5") {
      //send data to yalidine
      const postData = {
        keyword: "yalidine",
        data: [
          {
            order_id: "MyFirstOrder",
            firstname: ".",
            familyname: data.name,
            contact_phone: data.phone,
            address: adresse,
            to_commune_name: datat.filter(
              (d) => d.commune_name === data.commune,
            )[0].commune_name_ascii,
            to_wilaya_name: datat.filter((d) => d.wilaya_name === data.state)[0]
              .wilaya_name_ascii,
            product_list: `${productDetails}`,
            price: data.total,
            do_insurance: false,
            declared_value: data.total,
            freeshipping: data.deliveryPrice == 0 ? true : false,
            is_stopdesk: data.stopdeskDelivery ? data.stopdeskDelivery : false,
            stopdesk_id: 0,
            has_exchange: false,
            product_to_collect: null,
          },
        ],
      };

      axios
        .post(url5, postData, {
          headers: {
            "yalidine-id": store.Yalidineid,
            "yalidine-token": store.Yalidinetoken,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const tracking = response.data?.data?.MyFirstOrder.tracking;
          setDoc(doc(db, "orders", data.id), {
            ...data,
            deleveryStatus: "4",
            tracking: tracking,
            DC: status,
          });
        })
        .catch((error) => {
          console.error("Error in Axios request:", error);
          console.error("Error in Axios request:", error.message);
          setErrorMessage(getUploadLivraisonErrorMessage(error) || (error.response.data.error));
        });
    } else if (status === "6") {
      // Guepex company
      const postData = [
        {
          order_id: "MyFirstOrder",
          from_wilaya_name: `${store.ApitokenGW}`,
          firstname: ".",
          familyname: data.name,
          contact_phone: data.phone,
          address: adresse,
          to_commune_name: datat.filter(
            (d) => d.commune_name === data.commune,
          )[0].commune_name_ascii,
          to_wilaya_name: datat.filter((d) => d.wilaya_name === data.state)[0]
            .wilaya_name_ascii,
          product_list: `${productDetails}`,
          price: totalNumber,
          do_insurance: false,
          declared_value: totalNumber,
          freeshipping: true,
          is_stopdesk: data.stopdeskDelivery ? data.stopdeskDelivery : false,
          has_exchange: 0,
          product_to_collect: null,
        },
      ];

      axios
        .post(
          url6,
          {
            keyword: "gupex",
            data: [postData],
          },
          {
            headers: {
              "gupex-id": store.UserguidGuepex,
              "gupex-token": store.Apitokenguepex,
              "Content-Type": "application/json",
            },
          },
        )
        .then((response) => {
          const tracking = response.data?.data?.MyFirstOrder.tracking;
          setDoc(doc(db, "orders", data.id), {
            ...data,
            deleveryStatus: "4",
            tracking: tracking,
            DC: status,
          });
        })
        .catch((error) => {
          setErrorMessage(getUploadLivraisonErrorMessage(error) || (error.response.statusText));
        });
    } else if (status === "7") {
      //Elogistia company
      axios
        .post(
          `https://api.elogistia.com/insertCommande/?apiKey=${
            store.apielogistia
          }&name=${data.name}&firstname=a&mail=foorwebs@gmail.com&phone=${
            data.phone
          }&address=${adresse}&commune=${
            datat.filter((d) => d.commune_name === data.commune)[0]
              .commune_name_ascii
          }&fraisDeLivraison=0&remarque=${data.note}&stop_desk=${
            data.stopdeskDelivery ? 2 : 1
          }&wilaya=${
            datat.filter((d) => d.wilaya_name === data.state)[0].wilaya_code
          }&product=${productDetails}&price=${
            data.total
          }&modeDeLivraison=1&exchangeName=&IdCommande=1052847`,
        )
        .then((response) => {
          if (response.status === 200) {
            const tracking = response.data?.success;
            if (tracking) {
              setDoc(doc(db, "orders", data.id), {
                ...data,
                deleveryStatus: "4",
                tracking: tracking,
                DC: status,
              });
            } else {
              setErrorMessage(response.data?.Message);
            }
          }
        })
        .catch((error) => {
          setErrorMessage(getUploadLivraisonErrorMessage(error) || (error.response.data.Message));
          console.log(error);
        });
    } else if (status === "8") {
      // Zimou Express company
      const datatCommune = datat.find((d) => d.commune_name === data.commune);
      console.log("datatCommune:", datatCommune);
      const communeZimou =
        CommuneZimou.find((c) => c.id === datatCommune.pk)?.id ||
        CommuneZimou.find((c) => c.id === datatCommune.id)?.id;

      const postData = {
        name: data.nameproduct,
        client_last_name: ".",
        client_first_name: data.name,
        client_phone: data.phone,
        address: adresse,
        commune: communeZimou,
        wilaya: parseInt(
          datat.filter((d) => d.wilaya_name === data.state)[0].wilaya_code,
        ),
        order_id: data.id,
        weight: 1,
        delivery_type: "Flexible",
        price: parseInt(data.total),
        free_delivery: true,
        observation: data.note || "",
        type: "ecommerce",
      };
      console.log("Post Data:", postData);
      axios
        .post(`${store.zimouUrl}/api/v1/packages`, postData, {
          headers: {
            Authorization: `Bearer ${store.zimouToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("Response:", response);
          const tracking = response.data?.data?.tracking_code;
          if (tracking) {
            setDoc(doc(db, "orders", data.id), {
              ...data,
              deleveryStatus: "4",
              tracking: tracking,
              DC: status,
            });
            // Show success notification
            Swal.fire({
              icon: "success",
              title: t("ui.orderSent"),
              text: t("ui.checkZimou"),
              confirmButtonText: t("orders.datatable_templating_demo.okay"),
              confirmButtonColor: "#7e5395",
              timer: 3000,
              timerProgressBar: true,
              position: "bottom-end",
              toast: true,
              showConfirmButton: false,
            });
          } else {
            setErrorMessage(t("ui.zimouNoTracking"));
          }
        })
        .catch((error) => {
          console.error(error.response?.data);
          setErrorMessage(
            getUploadLivraisonErrorMessage(error) || (error.response?.data.message || "حدث خطأ أثناء إرسال الطلب"),
          );
        });
    } else if (status === "9") {
      const CiteMorooco = citeMorooco.find((d) => d.name === data.state);
      const formData = new FormData();
      formData.append("type", "SIMPLE");
      formData.append("business", store.AmeexId);
      formData.append("order_num", "ORDER_NUM_1");
      formData.append("replace", "true");
      formData.append("exchange_code", ""); // ضع الكود إذا عندك تبادل
      formData.append("open", "NO");
      formData.append("try", "YES");
      formData.append("fragile", "0");
      formData.append("receiver", data.name);
      formData.append("phone", data.phone);
      formData.append("city", CiteMorooco?.id);
      formData.append("address", adresse);
      formData.append("comment", data.note || "");
      formData.append("product", data.productName || "منتج من المتجر");
      formData.append("cod", parseInt(data.total));
      formData.append("products[0][id]", data.productId || ""); // UUID إذا متاح
      formData.append("products[0][qty]", "1");

      axios
        .post(
          "https://api.ameex.app/customer/Delivery/Parcels/Action/Type/Add",
          formData,
          {
            headers: {
              "C-Api-Id": `${store.AmeexId}`,
              "C-Api-Key": `${store.AmeexKey}`,
              "Content-Type": "multipart/form-data",
            },
          },
        )
        .then((response) => {
          const resApi = response.data?.api;

          if (resApi?.type === "success" && resApi?.data?.id) {
            const tracking = resApi.data.id;
            const trackingCode = resApi.data.code;

            // حفظ البيانات في Firestore
            setDoc(doc(db, "orders", data.id), {
              ...data,
              deleveryStatus: "4",
              tracking: tracking,
              trackingCode: trackingCode, // إن أردت تخزين الكود
              DC: status,
            });
          } else {
            // عرض تنبيه خطأ
            Swal.fire({
              icon: "error",
              title: t("ship.error"),
              text: t("ui.ameexNoTracking"),
              confirmButtonText: t("orders.datatable_templating_demo.okay"),
              confirmButtonColor: "#7e5395",
            });
          }
        })
        .catch((error) => {
          console.error(error.response?.data || error.message);
          Swal.fire({
            icon: "error",
            title: t("ui.sendOrderFailed"),
            text: t("ui.checkConnectionAccount"),
            confirmButtonText: t("orders.datatable_templating_demo.okay"),
            confirmButtonColor: "#7e5395",
          });
        });
    } else if (status === "10") {
      const states = states_lby.list;
      const state = states.find((s) => s.name === data.state);
      const stateId = state ? state.id : null;
      const url = `https://api.mdm.express/api/geo/countries/LBY/states/${stateId}/cities?perPage=1500`;

      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${store.mdm_apikey}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const city = response.data.list.find((c) => c.name === data.commune);
          const cityId = city?.id || "LBY004";
          const sku = products.find(
            (p) => p.name === data.products[0].name,
          )?.sku;
          const postData = {
            client: {
              firstName: ".",
              lastName: data.name,
              phone: data.phone,
              phone2: data.phone2,
            },
            confirmed: false,
            confirmedByUs: true,
            declaredValue: Number(totalNumber) || 0,
            destination: {
              cityId: cityId,
              streetAddress: adresse,
            },
            fragile: false,
            freeShipping: store?.delevery?.free || false,
            height: 0,
            isInsuranceEnabled: false,
            isStopDesk: data.stopdeskDelivery || false,
            length: 0,
            liquid: false,
            notes: data.note || "",
            openable: false,
            paymentMethod: "cash",
            products: [
              {
                _price: 10,
                _variantOf: sku,
                quantity: Number(data.qty) || 1,
                trackingId: sku,
              },
            ],
            storeId: `${store.mdm_storeId}`,
            totalPrice: Number(data.total) || 0,
            weight: 0,
            width: 0,
          };

          axios
            .post("https://api.mdm.express/api/v2/orders", postData, {
              headers: {
                Authorization: `Bearer ${store.mdm_apikey}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              if (response.status == 200) {
                setDoc(doc(db, "orders", data.id), {
                  ...data,
                  deleveryStatus: "4",
                  tracking: response.data.trackingId,
                  DC: status,
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: t("ship.error"),
                  text: t("ui.ameexNoTracking"),
                  confirmButtonText: t("orders.datatable_templating_demo.okay"),
                  confirmButtonColor: "#7e5395",
                });
              }
            })
            .catch((error) => {
              console.error(error.response?.data || error.message);
              Swal.fire({
                icon: "error",
                title: t("ui.sendOrderFailed"),
                text:
                  error.response.data.error.message ||
                  t("ui.checkConnectionAccount"),
                confirmButtonText: t("orders.datatable_templating_demo.okay"),
                confirmButtonColor: "#7e5395",
              });
            });
        })
        .catch((error) => {
          console.log(error);
          setErrorMessage(getUploadLivraisonErrorMessage(error) || (error.response?.statusText));
        });
    } else if (status === "11") {
      const postData = {
        order_id: "MyFirstOrder",
        from_wilaya_name: store.YalitecW,
        firstname: data.name,
        familyname: "",
        contact_phone: data.phone,
        address: data.address,
        to_commune_name: datat.filter((d) => d.commune_name === data.commune)[0]
          ?.commune_name_ascii,
        to_wilaya_name: datat.filter((d) => d.wilaya_name === data.state)[0]
          ?.wilaya_name_ascii,
        product_list: `${productDetails}`,
        price: data.total,
        do_insurance: false,
        declared_value: data.total,
        Width: 0,
        Height: 0,
        length: 0,
        Weight: 0,
        freeshipping: false,
        is_stopdesk: data.stopdeskDelivery || false,
        stopdesk_id: 0,
        has_exchange: false,
        product_to_collect: null,
      };

      // change to the new URL
      try {
        const response = await fetch(
          "https://backend.foorweb.store/api/SendOrdersYalitec",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              apiId: `${store.YalitecId}`,
              apiToken: `${store.YalitecToken}`,
              parcels: [postData],
            }),
          },
        );

        const result = await response.json();

        if (!response.ok) {
          console.error("Erreur Yalitec :", result);
        } else {
          const tracking = result?.MyFirstOrder.tracking;

          setDoc(doc(db, "orders", data.id), {
            ...data,
            deleveryStatus: "4",
            tracking: tracking,
            DC: status,
          });
        }
      } catch (error) {
        console.error("Erreur lors de la requête à l’API locale :", error);
      }
    } else if (status === "12") {
      const postData = {
        client_name: data.name,
        wilaya_name: data.state,
        order_note: "",
        phone_st: data.phone,
        phone_sc: data.phone2 || "",
        order_adress: data.address,
        commune_name: data.commune,
        product_name: productDetails,
        qte: 1,
        product_price: `${data.total}`,
        wilaya_mat: null,
        commune_postal: null,
        stopdesk_status: data.stopdeskDelivery || false,
        order_ref: data.id,
        order_brittle: false,
        order_exchange: false,
        order_refund: false,
        sku: null,
      };

      try {
        const response = await fetch(
          "https://api.colivraison.express/v2/orders/bulk",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${store.coliv_token}`,
              "coliv-public-key": `${store.coliv_pubKey}`,
              accept: "application/json",
            },
            body: JSON.stringify({
              orders: [postData],
            }),
          },
        );

        const result = await response.json();

        if (!response.ok) {
          console.error("Erreur Colivraison :", result);
        } else {
          const messageKey = Object.keys(result.messages)[0];
          const tracking = result.messages[messageKey].tracking;
          await setDoc(doc(db, "orders", data.id), {
            ...data,
            deleveryStatus: "4",
            tracking: tracking,
            DC: status,
          });
        }
      } catch (error) {
        console.error("Erreur lors de l’appel à l’API Colivraison :", error);
      }
    } else if (status === "13") {
      const wilayaMylrz = wilayaMylerzzz.Value.find(
        (d) => d.ArName === data.state,
      )?.Zones[0].Code;
      console.log("wilayaMylrz", wilayaMylrz);
      const mylerzOrderPayload = [
        {
          Package_Serial: data.index,
          Description: data.products[0].name || "Colis",
          Service_Type: data.stopdeskDelivery ? "CTC" : "CTD",
          PAYMENT_TYPE: "COD",
          Service: "ND",
          Service_Category: "DELIVERY",
          Street: data.address || "",
          Neighborhood: wilayaMylrz,
          COD_Value: parseFloat(data.total),
          Pieces: [
            {
              pieceNo: data.index,
              SpecialNotes: data.note || "",
            },
          ],
          Customer_Name: data.name,
          Mobile_No: data.phone,
          PickupDueDate: new Date().toISOString(),
        },
      ];
      console.log("data", data);
      console.log("mylerzOrderPayload", mylerzOrderPayload);

      try {
        const response = await fetch(
          "https://backend.foorweb.shop/api/addOrderMylerz",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${store.mylerzToken}`, // Remplace avec le bon token Mylerz
              Accept: "application/json",
            },
            body: JSON.stringify(mylerzOrderPayload), // tableau JSON directement
          },
        );

        const result = await response.json();
        console.log("result", result);

        if (response.IsErrorState) {
          console.error("❌ Erreur Mylerz :", result);
          setErrorMessage(
            t("error"),
            "فشل في إرسال الطلب إلى Mylerz",
            result.Value?.ErrorCode || "خطأ غير معروف",
          );
        } else {
          // Tu peux récupérer ici PickupOrderCode ou autre
          const tracking = result?.Value?.Packages?.[0]?.BarCode || null;

          await setDoc(doc(db, "orders", data.id), {
            ...data,
            deleveryStatus: "4",
            tracking: tracking,
            DC: status,
          });

          // await showAlert("success", "تم إرسال الطلب إلى Mylerz بنجاح", "");
          Swal.fire({
            icon: "success",
            title: t("ui.mylerzOrderSent"),
            text: t("ui.checkMylerz"),
            confirmButtonText: t("orders.datatable_templating_demo.okay"),
            confirmButtonColor: "#7e5395",
            timer: 3000,
            timerProgressBar: true,
            position: "bottom-end",
            toast: true,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        console.error("❌ Erreur d'appel à l’API Mylerz :", error);
        setErrorMessage(
          t("ui.mylerzConnectionError"),
          error.message || "حدث خطأ غير متوقع",
        );
        // await showAlert("فشل الاتصال بـ Mylerz", error.message || "حدث خطأ غير متوقع");
      }
    } else {
      await setDoc(doc(db, "orders", data.id), {
        ...data,
        deleveryStatus: "4",
        DC: status,
      });
    }
  };

  const handleMenuItemClick = async (status) => {
    const isShippingOption = shippingOptions.some(
      (opt) => opt.value === status,
    );
    if (isShippingOption) {
      await changeShip(status);
    } else {
      await changeStatus(status);
    }
  };

  const menu = (
    <Menu>
      {statusOptions2.map((status) => (
        <Menu.Item
          key={status.value}
          onClick={() => {
            changeStatus(status.value);
            setDropdownVisible(false);
          }}
          className={`flex items-center mt-2 ${
            order?.deleveryStatus === status.value ? "selected" : ""
          }`}
        >
          <div className="flex items-center justify-end space-x-4">
            <span>{status.label}</span>
            <img
              src={status.buttonImage}
              alt={status.label}
              style={{ width: "20px", marginRight: "8px" }}
            />
          </div>
        </Menu.Item>
      ))}
      {shippingOptions.length > 0 && (
        <>
          <Menu.Divider />
          {shippingOptions.map((option) => (
            <Menu.Item
              key={option.value}
              onClick={() => handleMenuItemClick(option.value)}
              className={`flex items-center ${
                order?.deleveryStatus === option.value ? "selected" : ""
              }`}
            >
              <div className="flex items-center justify-end space-x-4">
                <span>
                  {t(
                    "orders.datatable_templating_demo.upload_to_delivery_company",
                  )}{" "}
                  {option.label}
                </span>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                  alt={option.label}
                  style={{ width: "20px", marginRight: "8px" }}
                />
              </div>
            </Menu.Item>
          ))}
        </>
      )}
    </Menu>
  );

  const getStatusText = (status) => {
    return statusOptions[status] || "";
  };

  const customMessages = store?.orderMessages || {};
  const isMessagesEnabled = store?.orderMessagesEnabled !== false;

  const defaultMessages = {
    1: "",
    2: "",
    3: `مرحباً {customerName},\nتم تأكيد طلبك بنجاح .🛍 المنتج: {productName}\n💰إجمالي السعر: {totalAmount} {currencySymbol}\nسيتم تجهيز طلبك وإرساله في أقرب وقت.شكرا لثقتك. لا تتردد في التواصل إذا كان لديك أي استفسارات.\nبانتظار خدمتك مجدداً،\n`,
    4: `مرحباً {customerName},\nنود أن نعلمك أنه تم رفع طلبك لشركة التوصيل \n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount} {currencySymbol}\n  سيتصل بك الموزع خلال أيام ٫نرجو الاستعداد لاستلام المنتج والرد بسرعة. نقدر تفهمك وتعاونك، ونسعى دائمًا لخدمتك بشكل مميز`,
    5: "",
    6: ` مرحباً {customerName},\nنأسف لإبلاغك بأن طلبك قد تم إلغاؤه و السبب راجع لعدم ردك على إتصالاتنا .\n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount} {currencySymbol}\n إذا كنت مهتم لا تتردد في الاتصال بنا .\nبانتظار إتصالك`,
    "11-1": ` مرحباً {customerName},\nنحن في انتظار اتصالك لتأكيد طلبك .\n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount}{currencySymbol}\n    نود إعلامك أن الكمية المتاحة من المنتج قد تقترب من النفاذ. ننتظر اتصالك في أقرب وقت لتأكيد طلبك وضمان توفر المنتج لك\nطاب يومك,`,
    "11-2": `مرحباً {customerName},\nنأسف لعدم الرد على اتصالنا السابق.\nيرجى الاتصال  بنا لتأكيد طلبك:\n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount} {currencySymbol}\nبإنتظار تواصلك لتأكيد طلبك ،\n`,
    "11-3": ` مرحباً {customerName},\nنود إعلامك بأنه تم تأجيل طلبك:\n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount} {currencySymbol}\nسنتواصل معك قريبا لتحديد موعد الإستلام ،\n`,
    "11-4": `مرحباً {customerName},\n لقد قمنا بمحاولة الاتصال بك لتأكيد طلبك، ولكن وجدنا خطك مغلقًا\n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount} {currencySymbol}\n   يُرجى التأكد من تفعيل الاتصال و ننتظر اتصالك في أقرب وقت لتأكيد طلبك وضمان توفر المنتج لك \n طاب يومك,`,
    "11-5": ` مرحباً {customerName},\nنأسف لإلغاء طلبك .\n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount} {currencySymbol}\n إذا قررت طلب المنتج في وقت لاحق، فلا تتردد في الاتصال بنا. سنكون سعداء بخدمتك في المستقبل,`,
  };

  const getMessageByStatus = (status, orderData) => {
    let messageTemplate;

    if (
      isMessagesEnabled &&
      customMessages[status] &&
      customMessages[status].trim() !== ""
    ) {
      messageTemplate = customMessages[status];
    } else {
      messageTemplate = defaultMessages[status] || "";
    }
    let finalMessage = messageTemplate
      .replace(/{customerName}/g, orderData?.name || "")
      .replace(/{productName}/g, orderData?.nameproduct || "")
      .replace(/{totalAmount}/g, orderData?.total || "")
      .replace(/{currencySymbol}/g, store?.currencySymbol || "")
      .replace(/{orderNumber}/g, orderData?.id || "")
      .replace(
        /{orderDate}/g,
        orderData?.timeStamp
          ? new Date(orderData.timeStamp.seconds * 1000).toLocaleDateString(
              "fr-FR",
              {
                day: "numeric",
                month: "long",
                year: "numeric",
              },
            )
          : "",
      );

    return finalMessage;
  };

  const messagesByStatus = {
    1: getMessageByStatus(1, order),
    2: getMessageByStatus(2, order),
    3: getMessageByStatus(3, order),
    4: getMessageByStatus(4, order),
    5: getMessageByStatus(5, order),
    6: getMessageByStatus(6, order),
    "11-1": getMessageByStatus("11-1", order),
    "11-2": getMessageByStatus("11-2", order),
    "11-3": getMessageByStatus("11-3", order),
    "11-4": getMessageByStatus("11-4", order),
    "11-5": getMessageByStatus("11-5", order),
  };

  const handleTextButtonClick = () => {
    if (order?.locked) {
      Swal.fire({
        icon: "warning",
        title: t("ui.foorcallPaymentRequired"),
        text: t("ui.foorcallPhoneLocked"),
        confirmButtonText: t("orderDetails.alerts.ok"),
      });
      return;
    }

    if (!order || !order.phone) {
      Swal.fire(
        t("orderDetails.alerts.unblock.error"),
        t("orderDetails.alerts.call.noPhoneTitle"),
        "error",
      );
      return;
    }

    if (order.isValid) {
      Swal.fire({
        title: t("orderDetails.alerts.call.title"),
        text: t("orderDetails.alerts.call.text"),
        icon: "info",
        confirmButtonText: t("orderDetails.alerts.ok"),
      });

      return;
    }

    const message = messagesByStatus[order.deleveryStatus];
    console.log("order message", message);

    if (!message) {
      Swal.fire(t("orderDetails.alerts.unblock.error"), "", "error");
      return;
    }

    const encodedMessage = encodeURIComponent(message);

    const smsUrl = `sms:${order.phone}?body=${encodedMessage}`;

    window.location.href = smsUrl;
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <style>{`
          @keyframes logoPulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.2; transform: scale(0.85); }
          }
          @keyframes ripple {
            0% { transform: scale(0.8); opacity: 0.6; }
            100% { transform: scale(1.8); opacity: 0; }
          }
          .logo-pulse { animation: logoPulse 1.4s ease-in-out infinite; }
        `}</style>
        <div className="relative flex items-center justify-center w-32 h-32">
          <div className="ripple-ring" />
          <img
            src="/logo-new.png"
            alt={t("ui.logo")}
            width={300}
            height={300}
            className="logo-pulse relative z-10 object-contain"
          />
        </div>
      </div>
    );
  }

  if (!order) {
    return <div>{t("orderDetails.alerts.notFoundText")}</div>;
  }

  let buttonImage = "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
  let buttonImage2 =
    "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";

  switch (order?.deleveryStatus) {
    case "1":
      buttonImage = "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
      buttonImage2 =
        "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";
      break;
    case "2":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1688/1688988.png";
      buttonImage2 =
        "https://img.freepik.com/free-psd/delivery-box-isometric-3d-render-icon_47987-7574.jpg";
      break;
    case "3":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8888/8888205.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/8888/8888205.png";
      break;
    case "4":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/1559/1559859.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/1559/1559859.png";
      break;
    case "5":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/6815/6815043.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/6815/6815043.png";
      break;
    case "6":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/391/391247.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/391/391247.png";
      break;
    case "11-1":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/2593/2593514.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/2593/2593514.png";
      break;
    case "11-2":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/9946/9946401.png";
      break;
    case "11-3":
      buttonImage = "../agenda.png";
      buttonImage2 = "../agenda.png";
      break;
    case "11-4":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/8402/8402548.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/8402/8402548.png";
      break;
    case "11-5":
      buttonImage = "https://cdn-icons-png.flaticon.com/128/7787/7787073.png";
      buttonImage2 = "https://cdn-icons-png.flaticon.com/128/7787/7787073.png";
      break;
  }

  const handleCallClick = () => {
    // Check if the order is valid
    if (order.isValid) {
      Swal.fire({
        icon: "info",
        title: t("orderDetails.alerts.call.title"),
        text: t("orderDetails.alerts.call.text"),
        confirmButtonText: t("orderDetails.alerts.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      return; // Stop further execution if the order is valid
    }

    const phoneNumber = order.phone;

    // Check if the phone number exists
    if (!phoneNumber) {
      Swal.fire({
        icon: "error",
        title: t("orderDetails.alerts.call.noPhoneTitle"),
        text: t("orderDetails.alerts.call.noPhoneText"),
        confirmButtonText: t("orderDetails.alerts.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      return; // Stop further execution if phone number is missing
    }

    // Directly move to the phone call link without confirmation
    window.location.href = `tel:${phoneNumber}`;
  };

  // Avoid function running multiple times
  let isFunctionRunning = false;

  const handlePay = async () => {
    if (isFunctionRunning) return;
    isFunctionRunning = true;

    const isOnline = navigator.onLine;
    if (!isOnline) {
      Swal.fire({
        icon: "error",
        title: t("orderDetails.alerts.internet.title"),
        text: t("orderDetails.alerts.internet.text"),
        confirmButtonText: t("orderDetails.alerts.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      isFunctionRunning = false;
      return;
    }

    const currentDate = Math.floor(Date.now() / 1000);

    try {
      const nextAccount = await consumeSubscriptionToken({
        accountId: account?.id,
      });

      dispatch(fetchAccount(nextAccount));

      await updateDoc(doc(db, "orders", id), {
        isValid: false,
      });

      // Update UI without refresh
      setOrder((prev) => ({ ...prev, isValid: false }));

      Swal.fire({
        icon: "success",
        title: t("orderDetails.alerts.activation.successTitle"),
        confirmButtonText: t("orderDetails.alerts.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });

      isFunctionRunning = false;
      return nextAccount;
    } catch (error) {
      if (error?.code === "INSUFFICIENT_TOKENS") {
        Swal.fire({
          icon: "error",
          title: t("ship.insufficient_balance"),
          text: t("ship.insufficient_balance_message"),
          confirmButtonText: t("ship.recharge_balance"),
          confirmButtonColor: "rgb(141, 93, 167)",
          showCancelButton: true,
          cancelButtonText: t("annule"),
          cancelButtonColor: "#e87778",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = "/plan";
          }
          isFunctionRunning = false;
        });
        return;
      }

      console.error("Error while processing payment:", error);
      Swal.fire({
        icon: "error",
        title: t("orderDetails.alerts.insufficientBalance.title"),
        text: t("orderDetails.alerts.insufficientBalance.text"),
        confirmButtonText: t("orderDetails.alerts.ok"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      isFunctionRunning = false;
    }
  };

  const addIpToAdressipblock = async (order) => {
    Swal.fire({
      title: t("orderDetails.alerts.block.title"),
      text: t("orderDetails.alerts.block.text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
      confirmButtonText: t("orderDetails.alerts.block.confirm"),
      cancelButtonText: t("orderDetails.alerts.block.cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const storeDocRef = doc(db, "store", store.id);
        if (order.ipAddress) {
          try {
            await updateDoc(storeDocRef, {
              Adressipblock: arrayUnion(order.ipAddress),
            });
            apicache(account, products);
            Swal.fire(
              t("orderDetails.alerts.block.success"),
              t("orderDetails.alerts.block.successText"),
              "success",
            );
          } catch (error) {
            console.error("Error adding الايبي: ", error);
            Swal.fire(
              t("orderDetails.alerts.block.error"),
              t("orderDetails.alerts.block.errorText"),
              "error",
            );
          }
        } else {
          console.error("No الايبي address found in data");
          Swal.fire(
            t("orderDetails.alerts.block.error"),
            t("orderDetails.alerts.block.notFoundText"),
            "error",
          );
        }
      }
    });
  };

  const removeIpFromAdressipblock = async (order) => {
    Swal.fire({
      title: t("orderDetails.alerts.unblock.title"),
      text: t("orderDetails.alerts.unblock.text"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
      confirmButtonText: t("orderDetails.alerts.unblock.confirm"),
      cancelButtonText: t("orderDetails.alerts.unblock.cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const storeDocRef = doc(db, "store", store.id);

        if (order.ipAddress) {
          try {
            await updateDoc(storeDocRef, {
              Adressipblock: arrayRemove(order.ipAddress),
            });
            console.log("الايبي removed successfully!");
            Swal.fire(
              t("orderDetails.alerts.unblock.success"),
              t("orderDetails.alerts.unblock.successText"),
              "success",
            );
          } catch (error) {
            console.error("Error removing الايبي: ", error);
            Swal.fire(
              t("orderDetails.alerts.unblock.error"),
              t("orderDetails.alerts.unblock.errorText"),
              "error",
            );
          }
        } else {
          console.error("No الايبي address found in data");
          Swal.fire(
            t("orderDetails.alerts.unblock.error"),
            t("orderDetails.alerts.unblock.notFoundText"),
            "error",
          );
        }
      }
    });
  };

  const getUniqueDaysCount = (statusTimeline) => {
    if (!Array.isArray(statusTimeline)) return 0;

    const uniqueDates = new Set();

    statusTimeline.forEach((item) => {
      if (item.timestamp) {
        let timestamp = item.timestamp;

        // Validate timestamp and ensure it's a valid date
        if (timestamp.seconds) {
          timestamp = new Date(timestamp.seconds * 1000);
        } else if (isNaN(new Date(timestamp))) {
          return; // Skip invalid timestamp
        } else {
          timestamp = new Date(timestamp); // fallback
        }

        const dayString = timestamp.toISOString().split("T")[0]; // YYYY-MM-DD
        uniqueDates.add(dayString);
      }
    });

    return uniqueDates.size;
  };

  const tentativesCount = getUniqueDaysCount(order.statusTimeline);

  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#181919] min-h-screen"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 w-full mb-4 bg-[#fbf8fc] dark:!bg-[#141414]"
          style={{
            flex: 1,
          }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
          <div className="m-1 p-0 bg-white dark:!bg-[#181919] rounded-xl shadow-sm border border-purple-100 dark:!border-[#3c3a3d]">
            <div className="flex flex-col items-center  w-full">
              {/* الجزء العلوي الأزرق */}

              <div className="bg-[#5a2b73] w-full h-20 flex justify-center relative rounded-t-lg">
                <div className="absolute top-[10px] flex justify-center">
                  {order?.products?.map((product, index) => (
                    <div className="w-24 h-24 rounded-full border-4 border-[#5a2b73] p-1 bg-white">
                      <img
                        className="w-full h-full rounded-full"
                        src={
                          product.image ? product.image : "/product-foorweb.png"
                        }
                        alt={t("ui.profile")}
                      />
                    </div>
                  ))}
                </div>
              </div>
              {/* الجزء السفلي الأبيض */}
              {order?.products?.[0] && (
                <div className="bg-white dark:!bg-[#181919] text-gray-800 dark:text-gray-200 p-6 rounded-b-lg w-full mt-5 mb-2 relative">
                  <div className="flex items-center justify-between w-full">
                    <button
                      onClick={goToPrevious}
                      disabled={currentIndex === 0}
                      className={`p-2 rounded-full transition ${
                        currentIndex === 0
                          ? "opacity-50 cursor-not-allowed bg-gray-300"
                          : "bg-gray-200 hover:bg-gray-300"
                      }`}
                    >
                      {isRTL ? (
                        <ChevronRightIcon className="h-6 w-6 text-gray-700" />
                      ) : (
                        <ChevronLeftIcon className="h-6 w-6 text-gray-700" />
                      )}
                    </button>

                    {/* هذا div يستخدم لتوسيط المحتوى */}
                    <div className="absolute left-1/2 transform -translate-x-1/2 text-center">
                      {order.locked ? (
                        // Hidden for an unpaid FoorCall balance — the number
                        // isn't in `order` at all, so there's no tel: link to
                        // offer. Checked before isFreeCountry/isValid because
                        // neither of those can reveal what wasn't sent.
                        <p className="m-0 text-orange-600 font-bold">
                          {t("ui.phoneHiddenDebt")}
                        </p>
                      ) : isFreeCountry ? (
                        <a
                          href={`tel:${order.phone}`}
                          style={{ textDecoration: "none" }}
                        >
                          <p className="m-0 text-green-600 font-bold">
                            {order.phone}
                          </p>
                        </a>
                      ) : order.isValid ? (
                        <i className="fs-3" onClick={handlePay}>
                          <img
                            className="mx-auto"
                            src="/lock.png"
                            alt={t("orderDetails.top_section.image_alt")}
                          />
                        </i>
                      ) : (
                        <a
                          href={`tel:${order.phone}`}
                          style={{ textDecoration: "none" }}
                        >
                          <p className="m-0 text-green-600 font-bold">
                            {order.phone}
                          </p>
                        </a>
                      )}

                      <p className="text-gray-600 dark:text-gray-300">
                        {order.timeStamp
                          ? new Date(
                              order.timeStamp.seconds * 1000,
                            ).toLocaleString("ar-DZ", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: false,
                            })
                          : t("orderDetails.order_status_history.no_date")}
                      </p>
                    </div>

                    <button
                      onClick={goToNext}
                      disabled={currentIndex === orderIds.length - 1}
                      className={`p-2 rounded-full transition ${
                        currentIndex === orderIds.length - 1
                          ? "opacity-50 cursor-not-allowed bg-gray-300"
                          : "bg-gray-200 hover:bg-gray-300"
                      }`}
                    >
                      {isRTL ? (
                        <ChevronLeftIcon className="h-6 w-6 text-gray-700" />
                      ) : (
                        <ChevronRightIcon className="h-6 w-6 text-gray-700" />
                      )}
                    </button>
                  </div>
                </div>
              )}
              <div className="flex space-x-2 mb-3">
                <button
                  onClick={
                    !!account.store
                      ? () => handleUpdate(order)
                      : () => {
                          message();
                        }
                  }
                  className="flex items-center justify-center py-2.5 border rounded-lg dark:!bg-[#181919] dark:!border-[#3c3a3d] hover:bg-gray-50 dark:hover:bg-[#2a2a2a] duration-150 active:bg-gray-100 bot3"
                >
                  <img src="/faq.png" style={{ width: "20px" }} />
                </button>
                <button
                  onClick={handleTextButtonClick}
                  className="flex items-center justify-center py-2.5 border rounded-lg dark:!bg-[#181919] dark:!border-[#3c3a3d] hover:bg-gray-50 dark:hover:bg-[#2a2a2a] duration-150 active:bg-gray-100 bot3"
                >
                  <img src="/speech-bubble.png" style={{ width: "20px" }} />
                </button>
                <button
                  onClick={handleCallClick}
                  className="flex items-center justify-center py-2.5 border rounded-lg dark:!bg-[#181919] dark:!border-[#3c3a3d] hover:bg-gray-50 dark:hover:bg-[#2a2a2a] duration-150 active:bg-gray-100 bot3"
                >
                  <img src="/phone-call.png" style={{ width: "20px" }} />
                </button>
                <Dropdown
                  overlay={menu}
                  trigger={["click"]}
                  visible={dropdownVisible}
                >
                  <button
                    className="relative w-24 h-12 flex items-center justify-center border rounded-lg hover:bg-gray-50 dark:hover:bg-[#2a2a2a] dark:!border-[#3c3a3d] duration-150 active:bg-gray-100"
                    onClick={handleDropdownClick}
                  >
                    {/* الشارة */}
                    {tentativesCount > 0 && (
                      <span className="absolute -top-1 -left-1 w-5 h-5 flex items-center justify-center text-xs font-bold text-white bg-[#5a2b73] rounded-full">
                        {tentativesCount}
                      </span>
                    )}

                    {/* صورة الأيقونة */}
                    <img
                      src={
                        order
                          ? getButtonImage(order.deleveryStatus)
                          : "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                      }
                      className="w-5 h-5"
                      alt={t("ui.buttonIcon")}
                    />
                  </button>
                </Dropdown>
              </div>
              {order?.products?.map((product, index) => (
                <div
                  key={index}
                  className="max-w-2xl mx-auto py-0 md:px-2 relative mt-4 w-100 p-2"
                >
                  <div
                    onClick={() => toggleSubmenu(product.name)}
                    className="d-flex justify-content-between w-100 p-1-2 border4 card bg-white dark:!bg-[#181919] dark:text-gray-200 dark:!border-[#3c3a3d]"
                  >
                    <li className="flex gap-4 items-center">
                      <img
                        src={
                          product.image ? product.image : "/product-foorweb.png"
                        }
                        alt={product.name}
                        className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-purple-100"
                      />
                      <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                        {product.name}
                      </div>
                      <span className="text-sm">
                        {product.price} {product?.currencySymbol || t("ui.dzd")}
                      </span>
                      <i
                        className={`bi ${
                          showSubmenus[product.name]
                            ? "bi-chevron-double-up"
                            : "bi-chevron-double-down"
                        }`}
                        style={{ color: "#45a788" }}
                      ></i>
                    </li>
                  </div>

                  <div
                    className={`submenu ${
                      showSubmenus[product.name] ? "" : "open"
                    }`}
                  >
                    <div className="w-100 p-1-2 border4 bg-white dark:!bg-[#181919] dark:!border-[#3c3a3d] dark:text-gray-200">
                      {product.options?.offer && (
                        <div className="d-flex justify-content-between w-100 p-1-2-3">
                          <p className="m-0">
                            {t("orderDetails.product_details.offer")}
                          </p>
                          <p className="m-0 text-success">
                            <b>{product?.options?.offer}</b>
                          </p>
                        </div>
                      )}

                      <div className="d-flex justify-content-between w-100 p-1-2-3">
                        <p className="m-0">
                          {t("orderDetails.product_details.color")}
                        </p>
                        <p className="m-0 text-success">
                          <b>
                            {product.options?.color ||
                              t("orderDetails.order_summary.noQuantity")}
                          </b>
                        </p>
                      </div>
                      <hr className="m-0 p-0" />

                      <div className="d-flex justify-content-between w-100 p-1-2-3">
                        <p className="m-0">
                          {t("orderDetails.product_details.option")}
                        </p>
                        <p className="m-0 text-success">
                          <b>
                            {product.options?.size ||
                              t("orderDetails.order_summary.noQuantity")}
                          </b>
                        </p>
                      </div>
                      <hr className="m-0 p-0" />

                      <div className="d-flex justify-content-between w-100 p-1-2-3">
                        <p className="m-0">
                          {t("orderDetails.product_details.quantity")}
                        </p>
                        <p className="m-0 text-success">
                          <b>
                            {product.quantity ||
                              t("orderDetails.order_summary.noQuantity")}
                          </b>
                        </p>
                      </div>
                    </div>
                  </div>
                  <span
                    className="absolute top-0 left-0 p-1"
                    style={{
                      backgroundColor: "rgba(69, 167, 77, 0)",
                      marginTop: "-11px",
                    }}
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent click event from bubbling up
                    }}
                  >
                    <i
                      onClick={() => onDeleteProduct(product)} // Pass the product to delete
                      className="bi bi-x-circle"
                      style={{ color: "red", fontSize: "18px" }}
                    ></i>
                  </span>
                </div>
              ))}
              <div className="mt-4 grid gap-8 sm:grid-cols-2 lg:grid-cols-2 w-100 p-2">
                <div className=" justify-content-between w-100 p-1-2 border4 dark:!border-[#3c3a3d] card bg-white dark:!bg-[#181919] text-gray-700 dark:text-gray-300">
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">
                      {t("orderDetails.customer_info.full_name")}
                    </p>
                    <p className="m-0 text-green-600 font-bold">{order.name}</p>
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">
                      {t("orderDetails.customer_info.phone_number")}
                    </p>
                    {order?.locked ? (
                      // See the matching branch in the header block above —
                      // the number was never sent to the browser.
                      <p className="m-0 text-orange-600 font-bold text-end">
                        {t("ui.phoneHiddenDebt")}
                      </p>
                    ) : isFreeCountry ? (
                      <a
                        href={`tel:${order.phone}`}
                        style={{ textDecoration: "none" }}
                      >
                        <p className="m-0 text-green-600 font-bold">
                          {order.phone}
                        </p>
                      </a>
                    ) : order?.isValid ? (
                      <i className="fs-3" onClick={handlePay}>
                        <img
                          className="mx-auto "
                          src="/lock.png"
                          alt={t("orderDetails.top_section.image_alt")}
                        />
                      </i>
                    ) : (
                      <a
                        href={`tel:${order.phone}`}
                        style={{ textDecoration: "none" }}
                      >
                        <p className="m-0 text-green-600 font-bold">
                          {order.phone}
                        </p>
                      </a>
                    )}
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">
                      {t("orderDetails.customer_info.full_address")}
                    </p>
                    <p className="m-0 text-green-600 font-bold">
                      {order.state}, {order.commune}, {order.address}
                    </p>
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">
                      {t("orderDetails.customer_info.customer_note")}
                    </p>
                    <p className="m-0 text-green-600 font-bold">
                      {order.note || t("orderDetails.order_summary.noNote")}
                    </p>
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">
                      {t("orderDetails.customer_info.ip_address")}
                    </p>
                    <p className="m-0 text-green-600 font-bold">
                      <b>{order.ipAddress ? order.ipAddress : "-"}</b>
                    </p>
                  </div>
                </div>

                <div className=" justify-content-between w-100 p-1-2 border4 dark:!border-[#3c3a3d] card bg-white dark:!bg-[#181919] text-gray-700 dark:text-gray-300">
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">
                      {t("orderDetails.order_summary.product_value")}
                    </p>
                    <p className="m-0 text-green-600 font-bold">
                      {order.total - (order.deliveryPrice || 0)}{" "}
                      {order.currencySymbol}
                    </p>
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">
                      {t("orderDetails.order_summary.quantity")}
                    </p>
                    <p className="m-0 text-green-600 font-bold">{order.qty}</p>
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">
                      {t("orderDetails.order_summary.delivery")}{" "}
                    </p>
                    <p className="m-0 text-green-600 font-bold">
                      {order.deliveryPrice || 0} {order.currencySymbol}
                    </p>
                  </div>
                  <hr className="my-1" />
                  <div className="flex justify-between w-full px-2 py-1">
                    <p className="m-0">
                      {t("orderDetails.order_summary.total")}
                    </p>
                    <p className="m-0 text-green-600 font-bold">
                      {order.total} {order.currencySymbol}
                    </p>
                  </div>
                  <hr className="m-0 p-0" />
                  <div className="d-flex justify-content-between w-100 p-1-2-3 mt-2">
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      onClick={() => addIpToAdressipblock(order)}
                    >
                      {t("orderDetails.order_summary.block_button")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-warning"
                      onClick={() => removeIpFromAdressipblock(order)}
                    >
                      {t("orderDetails.order_summary.delete_button")}
                    </button>
                  </div>
                </div>
              </div>

              <div className="mt-12 w-100 p-3">
                <p className="text-gray-600 dark:text-gray-300 text-xl font-semibold sm:text-s">
                  {t("orderDetails.order_status_history.title")}
                </p>
                <ul className="mt-2 grid gap-8 sm:grid-cols-1 lg:grid-cols-1">
                  {order.statusTimeline ? (
                    order.statusTimeline.reverse().map((statusUpdate, idx) => (
                      <li
                        key={idx}
                        className="flex gap-4 items-center border4 bg-white dark:!bg-[#181919] dark:text-gray-200"
                        style={{
                          marginBottom: "-27px",
                        }}
                      >
                        <div className="flex-none w-24 h-24">
                          <img
                            src={
                              statusUpdate.status === "1"
                                ? "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                                : statusUpdate.status === "2"
                                  ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                                  : statusUpdate.status === "9"
                                    ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                                    : statusUpdate.status === "3"
                                      ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                      : statusUpdate.status === "4"
                                        ? "https://cdn-icons-png.flaticon.com/128/1559/1559859.png"
                                        : statusUpdate.status === "5"
                                          ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                                          : statusUpdate.status === "6"
                                            ? "https://cdn-icons-png.flaticon.com/128/391/391247.png"
                                            : statusUpdate.status === "6-1"
                                              ? "https://cdn-icons-png.flaticon.com/128/595/595067.png"
                                              : statusUpdate.status === "6-2"
                                                ? "/order6-2.png"
                                                : statusUpdate.status === "6-3"
                                                  ? "https://cdn-icons-png.flaticon.com/128/1828/1828843.png"
                                                  : statusUpdate.status ===
                                                      "6-4"
                                                    ? "https://cdn-icons-png.flaticon.com/128/2882/2882188.png"
                                                    : statusUpdate.status ===
                                                        "10"
                                                      ? "https://cdn-icons-png.flaticon.com/128/2933/2933116.png"
                                                      : statusUpdate.status ===
                                                          "11-1"
                                                        ? "https://cdn-icons-png.flaticon.com/128/2593/2593514.png"
                                                        : statusUpdate.status ===
                                                            "11-2"
                                                          ? "https://cdn-icons-png.flaticon.com/128/9946/9946401.png"
                                                          : statusUpdate.status ===
                                                              "11-3"
                                                            ? "../agenda.png"
                                                            : statusUpdate.status ===
                                                                "11-4"
                                                              ? "https://cdn-icons-png.flaticon.com/128/8402/8402548.png"
                                                              : statusUpdate.status ===
                                                                  "11-5"
                                                                ? "https://cdn-icons-png.flaticon.com/128/7787/7787073.png"
                                                                : "https://cdn-icons-png.flaticon.com/128/11442/11442042.png"
                            }
                            className="w-full h-full rounded-full"
                            alt=""
                            style={{
                              width: "35px",
                              height: "35px",
                              margin: "20px",
                            }}
                          />
                        </div>
                        <div>
                          <h4 className="font-semibold sm:text-lg">
                            {getStatusText(statusUpdate.status)}
                          </h4>
                          {statusUpdate.ownby && (
                            <p className="text-gray-500 dark:text-gray-400 text-sm mb-0">
                              {statusUpdate.ownby}
                            </p>
                          )}
                          <p className="text-[#9e68ba] mb-0">
                            {statusUpdate.timestamp
                              ? // Check if timestamp is a Firebase Timestamp object
                                statusUpdate.timestamp.seconds
                                ? new Date(
                                    statusUpdate.timestamp.seconds * 1000,
                                  ).toLocaleString("ar-DZ", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: false,
                                  })
                                : // If timestamp is already a JavaScript Date object or string
                                  new Date(
                                    statusUpdate.timestamp,
                                  ).toLocaleString("ar-DZ", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })
                              : t("orderDetails.order_status_history.no_date")}
                          </p>
                        </div>
                      </li>
                    ))
                  ) : (
                    <li className=""></li>
                  )}
                  <li
                    className="flex gap-4 items-center border4 bg-white dark:!bg-[#181919] dark:!border-[#3c3a3d] dark:text-gray-200"
                    style={{
                      marginBottom: "-27px",
                    }}
                  >
                    <div className="flex-none w-24 h-24 ">
                      <img
                        src={
                          "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                        }
                        className="w-full h-full rounded-full"
                        alt=""
                        style={{
                          width: "35px",
                          height: "35px",
                          margin: "20px",
                        }}
                      />
                    </div>
                    <div>
                      <h4 className=" font-semibold sm:text-lg">
                        {t("orderDetails.order_status_history.receive_order")}
                      </h4>
                      <p className="text-[#9e68ba]">
                        {/* {new Date(order.timestamp.seconds * 1000).toLocaleString()} */}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <ModalAdd
            lgShow={showModal}
            setLgShow={setShowModal}
            dataForm={dataForm}
            setDataForm={setDataForm}
            data={data}
            onSave={handleModalSave}
          />
          <Footer />
        </div>
      </div>
    </div>
  );
}
